<template>
  <div class="customer-consultation">
    <HeroBanner
        :background-image="bannerImage"
        title="고객과의 약속"
        sub-title="전문성을 바탕으로 한 최고의 보청기전문기업, <br>다비치 히어링 보청기입니다."
    />

    <div class="consultation-content">
      <!-- Section 1: 무료 청력검사 제공 -->
      <div class="promise-section">
        <div class="section-container">
          <h2 class="section-heading">01 <br> 무료 청력검사 제공</h2>
          <p class="section-text">
            다비치 히어링 보청기만의 차별화된 청력 분석 프로그램인 <br>
            이카스(ECAS)를 통해 <br>
            고객님의 난청 상태, 유형, 생활 습관 등을 종합적으로 <br>
            진단하여 가장 적합한 맞춤형 보청기를 제안합니다.
          </p>
        </div>
      </div>

      <!-- Section 2: 최대 한 달 무료착용 캠페인 -->
      <div class="promise-section">
        <div class="section-container">
          <h2 class="section-heading">02<br> 최대 한 달 무료착용 캠페인</h2>
          <p class="section-text">
            보청기를 처음 착용하는 고객님과 기존 보청기에 불편함을 <br>
            느끼는 고객님을 위해 최소 일주일에서 최대 한 달 무료착용 <br>
            캠페인을 진행하고 있습니다. <br>
            이러한 무료착용 캠페인을 통해 고객님의 보청기 적응을 <br>
            적극적으로 도와드립니다.
          </p>
        </div>
      </div>

      <!-- Section 3: 검증된 글로벌 보청기 가격 정찰제 -->
      <div class="promise-section">
        <div class="section-container">
          <h2 class="section-heading">03<br> 검증된 글로벌 보청기 가격 정찰제</h2>
          <p class="section-text">
            검증된 글로벌 보청기 브랜드 제조사와 협력하여 중간 <br>
            유통단계를 줄였습니다. <br>
            다비치 히어링 보청기 전국 어느 지점에서나 개인 맞춤형 <br>
            보청기를 가격 정찰제로 구매하실 수 있습니다.
          </p>
        </div>
      </div>

      <!-- Section 4: 구매 후 부적응 판정 시 환불 보장 -->
      <div class="promise-section">
        <div class="section-container">
          <h2 class="section-heading">04<br> 구매 후 부적응 판정 시 환불 보장</h2>
          <p class="section-text">
            다비치 히어링 보청기에서 보청기를 구매 후, <br>
            한 달 이내 착용 불편함이나 부적응 판정 시 구매금액 전액 <br>
            100% 환불 보장합니다. <br>
            (제품별 반품기간 상이)
          </p>
        </div>
      </div>

      <!-- Section 5: 분실파손 보험 -->
      <div class="promise-section">
        <div class="section-container">
          <h2 class="section-heading">05<br> 분실파손 보험</h2>
          <p class="section-text">
            보청기 구매 후, 분실파손 보험 가입 시 <br>
            구매 후 180일 이내 분실파손 시 구매 금액의 60% 금액으로 <br>
            재구매 가능하고, 1년 이내 분실파손 시 구매 금액의 80% <br>
            금액으로 재구매 가능합니다. (모든 프로모션 기간에 구매한 보청기는 기본 정찰가 기준으로 할인 적용)
          </p>
        </div>
      </div>

      <!-- Section 6: 사후 관리, A/S 무료 -->
      <div class="promise-section">
        <div class="section-container">
          <h2 class="section-heading">06<br> 사후 관리, A/S 무료</h2>
          <p class="section-text">
            다비치 히어링 보청기에서 구매한 모든 보청기는 특성화된 <br>
            교육과정을 수료한 전문 청각관리사를 통해 전국 매장에서 <br>
            무료로 사후관리, A/S가 진행됩니다.<br>
            (단, 고객 과실로 인한 사유는 유상처리되며 제조사별 상이)
          </p>
        </div>
      </div>

      <!-- Bottom Image -->
      <div class="promise-image">
        <img :src="contentImage" alt="고객과의 약속 이미지" />
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import PrivacyConsent from "@/components/PrivacyConsent.vue";
import bannerBg from '@/assets/images/heros/01-top-img.png';
import contentImage from '@/assets/images/banners/04_content_01.png';

export default {
  name: 'CustomerPromise',
  components: {
    HeroBanner,
    PrivacyConsent
  },
  data() {
    return {
      bannerImage: [bannerBg],
      contentImage: contentImage,
    };
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";

.customer-consultation {
  .consultation-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 55.8px 0 0;
    background: #FFFFFF;
    gap: 33.33px;

    .promise-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 0 0 5.58px;
      gap: 16.67px;

      .section-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 425px;
        max-width: 100%;
        .section-heading {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 700;
          font-size: 24px;
          line-height: 40px;
          letter-spacing: -0.05em;
          color: #222222;
          text-align: center;
          margin: 0 0 16.67px 0;
        }

        .section-text {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 350;
          font-size: 18px;
          line-height: 30px;
          letter-spacing: -0.04em;
          color: #222222;
          text-align: center;
          margin: 0;
        }
      }
    }

    .promise-image {
      width: 100%;
      max-width: 500px;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
      }
    }
  }

  @media (max-width: 768px) {
    .consultation-content {
      padding: 40px 0 0;
      gap: 24px;

      .promise-section {
        padding: 0 0 4px;
        gap: 12px;

        .section-container {
          width: 100%;
          padding: 0 16px;

          .section-heading {
            font-size: 20px;
            line-height: 32px;
            margin: 0 0 12px 0;
          }

          .section-text {
            font-size: 16px;
            line-height: 26px;
          }
        }
      }
    }
  }

  @media (max-width: 450px) {
    .consultation-content {
      padding: 30px 0 0;
      gap: 20px;

      .promise-section {
        .section-container {
          padding: 0 12px;

          .section-heading {
            font-size: 18px;
            line-height: 28px;
          }

          .section-text {
            font-size: 15px;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
